import { render, staticRenderFns } from "./WaiBuGongShi1.vue?vue&type=template&id=31072e20&scoped=true&"
import script from "./WaiBuGongShi1.vue?vue&type=script&lang=js&"
export * from "./WaiBuGongShi1.vue?vue&type=script&lang=js&"
import style0 from "./WaiBuGongShi1.vue?vue&type=style&index=0&id=31072e20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31072e20",
  null
  
)

export default component.exports